import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { INode } from 'common/interfaces/hierarchy-entities';

const customer = createSlice({
  name: 'node',
  initialState: {
    isLoading: false,
    nodes: [] as INode[],
    error: null,
  },
  reducers: {
    nodesRequested: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    nodesRecieved: (state, action) => {
      state.isLoading = false;
      state.nodes = action.payload;
    },
    nodesFailed: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  nodesRequested,
  nodesRecieved,
  nodesFailed,
} = customer.actions;

export default customer.reducer;

// @ts-ignore
export const getAllNodes = () => apiCallBegan({
  url: '/node/external',
  method: 'GET',
  onStart: nodesRequested.type,
  // @ts-ignore
  onSuccess: (response) => ({
    type: nodesRecieved.type,
    payload: response,
  }),
  onError: nodesFailed.type,
});
